import {atom} from "recoil";

const state = atom({
    key: 'usersPage',
    default: {}
});

export default state
